import { render, staticRenderFns } from "./eventoListList.vue?vue&type=template&id=4c99681d"
import script from "./eventoListList.vue?vue&type=script&lang=js"
export * from "./eventoListList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports